var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChildrenGirl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 71,
    viewBox: "0 0 53 71",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3042 11.9456L50.3043 11.9457C51.2318 12.8732 51.2318 14.3768 50.3043 15.3043L51.7185 16.7185L50.3043 15.3043L37.367 28.2416L36.5458 29.0628L36.852 30.1831L41.7448 48.0833H38.7812H36.7812V50.0833V66.125C36.7812 67.4367 35.7179 68.5 34.4062 68.5H32.2187C30.9071 68.5 29.8437 67.4367 29.8437 66.125V50.0833V48.0833H27.8437H25.6562H23.6562V50.0833V66.125C23.6562 67.4367 22.5929 68.5 21.2812 68.5H19.0937C17.7821 68.5 16.7187 67.4367 16.7187 66.125V50.0833V48.0833H14.7187H11.4455L16.6393 30.214L16.9694 29.0781L16.1329 28.2416L3.19567 15.3045C3.19566 15.3045 3.19566 15.3045 3.19566 15.3044C2.26814 14.3769 2.26814 12.8732 3.19567 11.9457L3.19572 11.9456C4.1231 11.0182 5.62688 11.0182 6.55425 11.9456L6.55431 11.9457L18.3978 23.7892L18.9836 24.375H19.8121H33.6878H34.5162L35.102 23.7892L46.9457 11.9457L46.9457 11.9456C47.8731 11.0182 49.3769 11.0182 50.3042 11.9456ZM18.9062 10.3438C18.9062 6.0117 22.4179 2.5 26.75 2.5C31.082 2.5 34.5937 6.0117 34.5937 10.3438C34.5937 14.6757 31.082 18.1875 26.75 18.1875C22.418 18.1875 18.9062 14.6757 18.9062 10.3438Z",
    stroke: "#0079FF",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildrenGirl);
export default __webpack_public_path__ + "static/media/children_girl.d9b6c0eb131d4c87eed3d7ea3ce66ca2.svg";
export { ForwardRef as ReactComponent };